export default {
  "home": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hallo!✨"])},
    "text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wie können wir Ihnen heute helfen? Wir sind hier für Sie, also lassen Sie uns ein Gespräch beginnen!"])}
  },
  "conversation": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktuelle Gespräche"])},
    "last_message_empty_caption": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Neues Gespräch..."])},
    "welcome_text": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Hallo! Willkommen bei ", _interpolate(_named("messengerName")), "."])},
    "enter_message_info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bitte geben Sie unten Ihre Frage ein, damit wir Ihre Frage schnell beantworten können."])},
    "compose": {
      "input_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Schreiben Sie eine Nachricht..."])}
    },
    "survey": {
      "post": {
        "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wir würden gerne wissen, was Sie von diesem Gespräch halten:"])},
        "thank_you_msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vielen Dank für Ihr Feedback! Dies wird uns helfen, unseren Service für Sie und andere zu verbessern."])}
      }
    },
    "status": {
      "sending": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senden..."])},
      "sent": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gesendet"])},
      "conversation_is_closed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Das Gespräch ist geschlossen"])}
    },
    "errors": {
      "404": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Das Gespräch konnte nicht geladen werden!"])}
    }
  },
  "archived_conversations": {
    "header": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Archivierte Gespräche (", _interpolate(_named("count")), ")"])}
  },
  "search": {
    "input_placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche nach Hilfsartikeln"])},
    "no_results": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Keine Ergebnisse für \"", _interpolate(_named("query")), "\""])},
    "no_results_hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bitte versuchen Sie ein anderes Schlüsselwort"])}
  },
  "channels": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wie möchten Sie heute in Kontakt treten?"])},
    "whatsapp": {
      "card_header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senden Sie eine WhatsApp-Nachricht"])},
      "qr_code_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scannen Sie mit Ihrer Kamera-App oder klicken Sie auf den QR-Code, um ein Gespräch zu beginnen."])},
      "button_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["WhatsApp öffnen"])},
      "number_undefined_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nummer ist nicht definiert."])},
      "initial_text_msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hallo Team! Ich habe mich gefragt..."])}
    }
  },
  "agents": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "availability": {
      "online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unser Support-Team ist online"])},
      "offline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
    },
    "status": {
      "online": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Online"])},
      "offline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Offline"])},
      "away": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abwesend"])}
    },
    "is_typing": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("agentName")), " schreibt..."])}
  },
  "forms": {
    "fields": {
      "_CONTACT_NAME": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_CONTACT_EMAIL": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["vorname", "@", "firma.com..."])}
      },
      "_CONTACT_PHONE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Telefon"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["(z.B. 0612345678)"])}
      },
      "_SUBJECT": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Betreff"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_INITIAL_MESSAGE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Frage"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "_MESSAGE": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nachricht"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      }
    },
    "types": {
      "PRE_CHAT": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Füllen Sie das Formular unten aus, damit wir Sie kennenlernen können 😄"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senden Sie Ihre Nachricht"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wir werden Sie mit einem unserer Teammitglieder verbinden!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oops, das Gespräch konnte nicht gestartet werden. Können Sie es noch einmal versuchen?"])}
      },
      "CONTACT_DETAILS": {
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Füllen Sie das Formular unten aus, damit wir in Kontakt bleiben können"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Absenden"])},
        "dismiss-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nicht jetzt"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vielen Dank, dass Sie Ihre E-Mail-Adresse angegeben haben."])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oops, das Formular konnte nicht übermittelt werden"])}
      },
      "EMAIL": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Schreiben Sie uns"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Füllen Sie das Formular unten aus, um mit unserem Kundensupport-Team in Kontakt zu treten"])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senden Sie Ihre Nachricht"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Das E-Mail-Formular wurde gesendet!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oops, die E-Mail konnte nicht zugestellt werden. Bitte versuchen Sie es erneut."])}
      },
      "WHATSAPP_CONTACT": {
        "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Beginnen Sie ein WhatsApp-Gespräch"])},
        "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stellen Sie sich vor und stellen Sie Ihre Frage, damit wir Ihnen sofort helfen können."])},
        "submit-btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Senden Sie Ihre Nachricht"])},
        "default-success-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Das WhatsApp-Kontaktformular wurde gesendet!"])},
        "default-error-msg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oops, das WhatsApp-Kontaktformular konnte nicht übermittelt werden. Können Sie es noch einmal versuchen?"])}
      }
    }
  },
  "mailform": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail-Formular"])},
    "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Füllen Sie das Formular unten aus, um sich an unser Kundensupport-Team zu wenden"])},
    "fields": {
      "NAME": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "SUBJECT": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Betreff"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "QUESTION": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Frage"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "EMAIL": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
      },
      "UPLOAD": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        "add_btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anhang hinzufügen"])}
      },
      "TOPIC": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Thema"])},
        "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Auswählen..."])}
      }
    },
    "notifications": {
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Das E-Mail-Formular wurde gesendet!"])},
      "errors": {
        "default": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Leider konnte das Formular nicht gesendet werden. Können Sie es noch einmal versuchen?"])}
      }
    },
    "submit_btn": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nachricht senden"])}
  },
  "common": {
    "buttons": {
      "start_new_conversation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lasst uns ein Gespräch beginnen."])},
      "show_archived_conversations": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Archivierte Gespräche anzeigen (", _interpolate(_named("count")), ")"])},
      "go_to_mailform": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Stattdessen eine E-Mail senden"])},
      "go_back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zurück"])}
    },
    "page_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["💬 Neue Nachricht \"", _interpolate(_named("message")), "\""])},
    "toast": {
      "generic_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oops, etwas ist schiefgelaufen!"])},
      "message_sent_error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Beim Senden der Nachricht ist ein Fehler aufgetreten"])},
      "giphy_no_results": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Es konnte kein Giphy-Bild gefunden werden."])}
    },
    "errors": {
      "upload_too_large": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Die Dateigröße darf 5 MB nicht überschreiten"])},
      "upload_file_type_disallowed": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Dieser Dateityp ist nicht zulässig"])}
    }
  },
  "gdpr": {
    "header": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GDPR Cookie-Einwilligung"])},
    "body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hallo! Wir würden gerne mit Ihnen sprechen. Gemäß der EU-Datenschutz-Grundverordnung benötigen wir jedoch zunächst Ihre Zustimmung für die Verwendung personenbezogener Daten (z.B. Ihren Namen und Ihre E-Mail-Adresse). Stimmen Sie zu, dass:<br><br>1) Wir Ihre persönlichen Daten speichern, damit wir das Gespräch später wieder aufnehmen können;<br><br>2) Wir Ihnen E-Mails senden dürfen, um unser Gespräch hier fortzusetzen;<br><br>3) Wir Ihnen E-Mails über unsere kommenden Dienstleistungen und Aktionen senden dürfen.<br>"])},
    "disapprove_body": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Das ist in Ordnung. Sie können die Bedingungen und Richtlinien jederzeit einsehen und zustimmen, um fortzufahren"])},
    "yes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ja, kein Problem"])},
    "no": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nein, heute nicht"])}
  },
  "powered_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Powered by Grasp"])}
}